import React, { useState } from "react";
import SettingsLayout from "../../../layouts/SettingsLayout";
import SettingsHeading from "../../../settings/SettingsHeading";
import Recruiter from "../../../../apiResources/Recruiter";
import RecruiterUser from "../../../../apiResources/RecruiterUser";
import Employer from "../../../../apiResources/Employer";
import EmployerUser from "../../../../apiResources/EmployerUser";
import Loader from "../../../library/Loader";
import AddressSettingsOption from "../../../settings/AddressSettingsOption";

const Location = (props: Props) => {
  const [editFocus, setEditFocus] = useState<string>(null);
  const { user, company } = props;

  const isDisabled = (value) => Boolean(editFocus) && editFocus !== value;
  const isEditing = (value) => Boolean(editFocus) && editFocus === value;

  if (!user || !company) {
    return (
      <SettingsLayout>
        <Loader />
      </SettingsLayout>
    );
  }

  return (
    <SettingsLayout user={user} company={company}>
      <SettingsHeading>Location</SettingsHeading>
      <AddressSettingsOption
        user={user}
        company={company}
        disabled={isDisabled("address")}
        onEditStart={() => setEditFocus("address")}
        isEditing={isEditing("address")}
        onEditComplete={() => setEditFocus(null)}
      />
    </SettingsLayout>
  );
};

type Props = {
  user: RecruiterUser | EmployerUser;
  company: Recruiter | Employer;
};

export default Location;
